<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">海报机</div>
          <div class="contentBottom">
            <div>动态展示，做互联网营销的数字广告牌</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="topText">颠覆传统信发系统，以Html5页面为播放单位、网络实时管理的海报机。与传统的广告机相比，不是一台多媒体播放器，而是一台互联网智能终端</div>
    <!-- start -->
    <div class="titleBox" style="margin-top:0">
      <div class="anliTitle">应用场景</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start 灰块 -->
    <div class="greyFlex">
      <div class="greyBox">
        <img :src="greyIcon1" alt>
        <div class="greyBoxText">零售门店</div>
      </div>
      <div class="greyBox">
        <img :src="greyIcon2" alt>
        <div class="greyBoxText">商场超市</div>
      </div>
      <div class="greyBox">
        <img :src="greyIcon3" alt>
        <div class="greyBoxText">展厅展馆</div>
      </div>
      <div class="greyBox">
        <img :src="greyIcon4" alt>
        <div class="greyBoxText">其他</div>
      </div>
    </div>
    <!-- end 灰块 -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">产品特色</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- 产品特色 start -->

    <div class="bgColor paddingBottom86">
      <!-- start -->
      <div class="productParent marginTop109 bgColor">
        <div class="productLeft">
          <img :src="changJingImg1">
        </div>
        <div class="productRight">
          <div class="productRightTitleTwo">动态H5</div>
          <div
            class="productRightText rightText1"
          >播放的是多图层的H5页面，重点信息以动态展示，更易吸引关注；模板化编辑工具，可修改‘文字’‘图片’等元素，快速发布新海报。</div>
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="productParentTwo">
        <div class="productLeftTwo">
          <div class="productRightTitleTwo">定时播放</div>
          <div
            class="productRightText productRightTextTwo"
          >配置轮播、定时播放、独占等播放机制，满足品牌营销需求，针对不同时段的场景需求，自动展示不同内容。</div>
        </div>
        <div class="productRightTwo">
          <img :src="changJingImg2">
        </div>
      </div>
      <!-- end -->
      <!-- start -->

      <div class="productParent bgColor">
        <div class="productLeft">
          <img :src="changJingImg3">
        </div>
        <div class="productRight">
          <div class="productRightTitleTwo">多终端管理</div>
          <div class="productRightText rightText1">支持多端管理，手机、电脑、pad端均可进行修改、发布等管理。</div>
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="productParentTwo">
        <div class="productLeftTwo">
          <div class="productRightTitleTwo">连锁门店，统一运营</div>
          <div
            class="productRightText productRightTextTwo"
          >多层级管理机制，总部可直接下发内容到所有门店，也可根据区域营销需求，发布内容到指定店铺/区域。</div>
        </div>
        <div class="productRightTwo">
          <img :src="changJingImg4">
        </div>
      </div>
      <!-- end -->
      <!-- start -->
      <div class="titleBox marginTop142">
        <div class="anliTitle">管理平台</div>
        <div class="lineCss"></div>
      </div>
      <!-- end -->
      <!-- 管理平台 start -->
      <div class="adminFlex">
        <div class="adminBox">
          <img :src="adminImg1" class="adminBoxImg" alt>
          <div class="textBox">
            <!-- <div class="adminTitle">内容管理</div>
            <div class="adminText">选模板-换素材-改文字</div> -->
          </div>
        </div>
        <div class="adminBox">
          <img :src="adminImg2" class="adminBoxImg"  alt>
          <div class="textBox">
            <!-- <div class="adminTitle">播放管理</div>
            <div class="adminText">轮播 | 独占 | 定时 | 插播 | 紧急下发</div> -->
          </div>
        </div>
        <div class="adminBox">
          <img :src="adminImg3" class="adminBoxImg"  alt>

          <div class="textBox">
            <!-- <div class="adminTitle">设备管理</div>
            <div class="adminText">监播 | 网络监测 | 开关机</div> -->
          </div>
        </div>
      </div>
      <!-- 管理平台 end -->
      <!-- start -->
      <div class="titleBox marginTop142">
        <div class="anliTitle">硬件选型</div>
        <div class="lineCss"></div>
      </div>
      <!-- end -->
      <div class="adminFlex borderTwoCss">
        <div class="adminBox borderCss">
          <img :src="posterBottomImg1" class=" adminBoxImgTwo" alt>
          <!-- <div class="iconBottomText">壁挂一体机</div> -->
        </div>
        <div class="adminBox borderCss">
          <img :src="posterBottomImg2" class="adminBoxImgTwo" alt>
          <!-- <div class="iconBottomText">立式一体机</div> -->
        </div>
        <div class="adminBox borderCss" >
          <img :src="posterBottomImg3 " class=" adminBoxImgTwo" alt>
          <!-- <div class="iconBottomText">数拓盒子</div> -->
        </div>
         <div class="adminBox " style="border-right:0;">
          <img :src="xuanXing4 " class=" adminBoxImgTwo" alt>
          <!-- <div class="iconBottomText">数拓盒子</div> -->
        </div>
      </div>
    </div>
    <!-- 产品特色 end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/posterTop.png";

import greyIcon1 from "@/assets/images/greyIcon1.png";
import greyIcon2 from "@/assets/images/greyIcon2.png";
import greyIcon3 from "@/assets/images/greyIcon3.png";
import greyIcon4 from "@/assets/images/greyIcon4.png";

import changJingImg1 from "@/assets/images/posterProduct1.png";
import changJingImg2 from "@/assets/images/posterProduct2.png";
import changJingImg3 from "@/assets/images/posterProduct3.png";
import changJingImg4 from "@/assets/images/posterProduct4.png";

import adminImg1 from "@/assets/images/adminImg1.png";
import adminImg2 from "@/assets/images/adminImg2.png";
import adminImg3 from "@/assets/images/adminImg3.png";

import posterBottomImg1 from "@/assets/images/xuanXing1.png";
import posterBottomImg2 from "@/assets/images/xuanXing2.png";
import posterBottomImg3 from "@/assets/images/xuanXing3.png";
import xuanXing4 from "@/assets/images/xuanXing4.png";
import Bread from '@/components/bread.vue'
export default {
  name: "ProductPoster",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild:['产品','海报机'],
      bgImg: bgImg,
      greyIcon1: greyIcon1,
      greyIcon2: greyIcon2,
      greyIcon3: greyIcon3,
      greyIcon4: greyIcon4,
      changJingImg1: changJingImg1,
      changJingImg2: changJingImg2,
      changJingImg3: changJingImg3,
      changJingImg4: changJingImg4,
      adminImg1: adminImg1,
      adminImg2: adminImg2,
      adminImg3: adminImg3,
      posterBottomImg1: posterBottomImg1,
      posterBottomImg2: posterBottomImg2,
      posterBottomImg3: posterBottomImg3,
      xuanXing4: xuanXing4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.topText {
  width: 70%;
  margin: auto;
  max-width: 890px;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 88px;
  margin-bottom: 99px;
}

/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 119px;
}

/* end */
.greyFlex {
  display: flex;
  width: 70%;
  margin: auto;
  padding: 100px 15%;
  background: rgba(238, 238, 238, 1);
  margin-top: 61px;
  margin-bottom: 127px;
}

.greyBox {
  width: 24%;
  text-align: center;
}

.greyBoxText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 10px;
}
.productParent{
  width: 70%;
  margin: auto;
}
.productParent::after {
  content: "";
  display: block;
  clear: both;
}

.productLeft {
  width: 50%;
  float: left;
}

.productLeft img {
  width: 100%;
  /* max-width: 711px; */
}

.productRight {
  width: 38%;
  padding-left: 8%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 46px;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family:PingFangSC-Light;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 43px;
}

.marginTop109 {
  margin-top: 59px;
}

.grayBoxText {
  width: 53%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 58px;
}

.productParentTwo::after {
  content: "";
  display: block;
  clear: both;
}

.productParentTwo {
  margin-top: 50px;
  width: 70%;
  margin: auto;
}

.productLeftTwo {
  width: 29%;
  float: left;
  padding-left: 12.5%;
}

.productRightTwo {
  width: 50%;
  float: right;
  text-align: right;
}

.productRightTwo img {
  width: 100%;
  /* max-width: 709px; */
}

.productRightTextTwo {
  margin: auto;
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.productRightTitleTwo {
  font-size: 3.2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 27px;
  margin-top: 90px;
  margin-bottom: 38px;
}

.productParent {
  /* margin-top: 50px; */
}

.paddingBottom86 {
  padding-bottom: 86px;
}

.marginTop142 {
  margin-top: 142px;
}

/* start */
.adminFlex {
  width: 70%;
  min-width: 810px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  margin-top: 85px;
}

.adminBox {
  text-align: center;
  position: relative;
  width: 33%;
}
.adminBoxImg{
  width: 95%;
  max-width: 365px;
}

.textBox {
  position: absolute;
  left: calc(50% - 160px);
  bottom: 20px;
}

.adminTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 5px;
}

.adminText {
  width: 320px;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(106, 106, 106, 1);
}

.iconBottomText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
  margin-top: 15px;
}
.borderCss {
  border-right: 1px solid rgba(107,107,107,1);;
  transition: .5s;
}
.borderCss:hover{
  /* box-shadow: 0px 3px 27px 0px rgba(0, 0, 0, 0.1); */
}
.marginTop20 {
  margin-top: 20px;
}
.adminBoxImgTwo{
  width: 100%;

}
.borderTwoCss{
  border: 1px solid rgba(107,107,107,1);
}

/* end */
</style>



// WEBPACK FOOTER //
// src/view/ProductPoster.vue